<div>
  <div class="menuHeading" (click)="menuSelected($event)">
    <div class="menuText">Group Tags</div>
    <svg
      *ngIf="!active && !fromMegaMenu"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
    >
      <path
        d="M1.75 1L6.25 6L1.75 11"
        stroke="#000F29"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      *ngIf="active && !fromMegaMenu"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
    >
      <path
        d="M1 6.25L6 1.75L11 6.25"
        stroke="#000F29"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
  <div *ngIf="active" [class.childWrapperShowMore]="fromMegaMenu">
    <div *ngFor="let item of filteredItems;let i = index" class="childWrapper">
      <div class="menuChild" (click)="toggleItem(item)" [ngClass]="{'openedGroup': !item.toggle}">
        <div class="menuChildText">{{item.name}}</div>
        <svg
          *ngIf="item.toggle"
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
        >
          <path
            d="M1.75 1L6.25 6L1.75 11"
            stroke="#000F29"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <svg
          *ngIf="!item.toggle"
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
        >
          <path
            d="M1 6.25L6 1.75L11 6.25"
            stroke="#000F29"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div [hidden]="item.toggle">
        <div
          *ngFor="let child of item.childList | search: 'name': myInput.value"
        >
          <div
            
            [ngClass]="{'active-menu': currentActiveTab?.header === 'Tag:'+child.name, 'menuChild': activeTab?.header !== 'Tag:'+child.name}"
          >
            <div class="textlink">
              <div class="menuChildText" (click)="itemSelected(item, child,false)">{{child.name}}</div>
              <img  alt="Open" 
              src="assets/Inbox/openInNewTab.svg"  class="hoverIcon" pTooltip="Open in a New Tab"
              tooltipPosition="top"
              tooltipStyleClass="leftTooltip ui-tooltip-text" (click)="itemSelected(item, child,true)">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="search-list">
    <input
      type="text"
      #myInput
      placeholder="{{placeholder}}"
      (input)="filterItem(myInput.value)"
    />
  </div>
</div>
